import classNames from 'classnames';

type InputLabelProps = {
  label?: string;
  variant?: 'default' | 'large';
  required?: boolean;
  htmlFor?: string;
};

export const InputLabel = ({ label, variant = 'default', required, htmlFor }: InputLabelProps) => {
  if (!label) {
    return null;
  }

  const isLarge = variant === 'large';
  const labelClassName = isLarge ? 'text-base font-semibold text-gray-900' : 'text-sm text-gray-500';

  return (
    <label className={classNames('block text-wrap', labelClassName)} htmlFor={htmlFor}>
      {label}
      {Boolean(required) && <span className="text-procuros-green-600"> *</span>}
    </label>
  );
};
